import React from 'react';
import PropTypes from 'prop-types';
import BuildChildren from 'utils/BuildChildren';
import CardIconA from 'components/CardIcon/CardIconA';
import Button from 'components/Button';
import classes from './CardImageH.module.scss';

const CardImageH = (props) => {
  const {
    heading,
    subHeading,
    contentMarkup,
    imageURI,
    imageLink,
    iconLinks,
  } = props;

  return (
    <div className={classes.container} style={{ backgroundImage: `url(${imageURI})` }}>
      <div className={classes.contentContainer}>
        {subHeading &&
          <div className={classes.stateInfo}>
            <span
              className={classes.stateText}
              dangerouslySetInnerHTML={{ __html: subHeading }}
            />
            {imageLink && BuildChildren(imageLink)}
          </div>}
        {heading &&
          <div
            className={classes.title}
            dangerouslySetInnerHTML={{ __html: heading }}
          />}
        {contentMarkup &&
          <div
            className={classes.description}
            dangerouslySetInnerHTML={{ __html: contentMarkup }}
          />}
        {iconLinks && iconLinks.length > 0 &&
          <div className={classes.cards}>
            {iconLinks.map((card, i) => {
              const { title: cardHeading, href: cardHref, target: cardTarget, icon: cardIcon } = card;
              // So we can reuse as much our existing components, we are rendering a CardIconA for tablets and desktops
              // and a Button with a new styles for the mobile view.
              // We could have cretaed a new component or do all here too, but went for this since it seemed cleaner
              return (
                <div className={classes.card} key={i}>
                  <CardIconA heading={cardHeading} icon={cardIcon} link={card} className={classes.cardIcon} />
                  <Button
                    subType='ButtonD'
                    title={cardHeading}
                    leftIcon={cardIcon}
                    rightIcon='far fa-chevron-right'
                    href={cardHref}
                    target={cardTarget}
                    className={classes.mobileButton}
                  />
                </div>
              );
            })}
          </div>}
      </div>
    </div>
  );
};

CardImageH.propTypes = {
  /**
   * Heading on the card
  */
  heading: PropTypes.string,
  /**
   * Sub heading on the card
  */
  subHeading: PropTypes.string,
  /**
   * Content of the card
  */
  contentMarkup: PropTypes.string,
  /**
   * Image URL
  */
  imageURI: PropTypes.string,
  /**
   * Image Link Object
  */
  imageLink: PropTypes.shape({
    title: PropTypes.string,
    href: PropTypes.string,
    target: PropTypes.string,
    imageUrl: PropTypes.string,
    altText: PropTypes.string,
  }),
  /**
   * Array of Link Objects, each rendered in a box using a CardIconA
  */
  iconLinks: PropTypes.array,
};

export default CardImageH;
